module.exports = __webpack_public_path__ + "img/newimgtu.0f18cd6b.png";